import i18n from 'modules/core/lib/i18n'

const getFeatureName = (feature: string): string | undefined => {
  const features: { [key: string]: string } = {
    balance_carryover_updated: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.features.balance_carryover_updated'
    ),
    break_setting_updated: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.features.break_setting_updated'
    ),
    tolerance_setting_updated: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.features.tolerance_setting_updated'
    ),
    setting_updated: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.features.setting_updated'
    ),
  }

  return features[feature]
}

const getFieldName = (field: string): string | undefined => {
  const fields: { [key: string]: string } = {
    automatic_breaks: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.automatic_breaks'
    ),
    base_minimal_duration: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.base_minimal_duration'
    ),
    clock_in_after: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.clock_in_after'
    ),
    clock_in_before: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.clock_in_before'
    ),
    clock_out_after: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.clock_out_after'
    ),
    clock_out_before: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.clock_out_before'
    ),
    description: i18n.t('time_tracking.settings.versions.sidepanel.messages.fields.description'),
    desktop_clockin: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.desktop_clockin'
    ),
    effective_at: i18n.t('time_tracking.settings.versions.sidepanel.messages.fields.effective_at'),
    enable_breaks: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.enable_breaks'
    ),
    id_clock_shared_device: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.id_clock_shared_device'
    ),
    geolocation: i18n.t('time_tracking.settings.versions.sidepanel.messages.fields.geolocation'),
    manual_breaks: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.manual_breaks'
    ),
    mobile_clockin: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.mobile_clockin'
    ),
    name: i18n.t('time_tracking.settings.versions.sidepanel.messages.fields.name'),
    reset_frequency: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.reset_frequency'
    ),
    overtime_authorization: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.overtime_authorization'
    ),
    qr_code_clockin: i18n.t(
      'time_tracking.settings.versions.sidepanel.messages.fields.qr_code_clockin'
    ),
  }

  return fields[field]
}

export { getFeatureName, getFieldName }
